(function(algolia) {
  'use strict';

  if (Shopify.locale == "it") {
    algolia.translations = {
      search: 'Ricerca attuale',
      noCollectionFound: 'Nessuna raccolta trovata',
      allProducts: 'Vedi tutti i prodotti',
      matching: 'coincidenza',
      sortBy: 'Ordinato per',
      relevance: 'Rilevanza',
      outOf: 'al di fuori',
      resultsFound: 'risultati trovati',
      oneResultFound: '1 risultato trovato',
      noResultFound: 'Nessun risultato trovato',
      addToCart: 'Aggiungi al carrello',
      searchForProduct: 'Cerca prodotti',
      selectedFilter: 'Filtri selezionati',
      clearAll: 'Cancella tutto',
      noPageFound: 'Nessuna pagina trovata',
      outOfStock: 'Esausto',
    };
  } else if (Shopify.locale == "es") {
    algolia.translations = {
      search: 'Búsqueda actual',
      noCollectionFound: 'No se encontró ninguna colección',
      allProducts: 'Ver todos los productos',
      matching: 'coincidencia',
      sortBy: 'Ordenado por',
      relevance: 'Relevancia',
      outOf: 'fuera de',
      resultsFound: 'resultados encontrados',
      oneResultFound: '1 resultado encontrado',
      noResultFound: 'No se encontró ningún resultado',
      addToCart: 'Añadir a la cesta',
      searchForProduct: 'Buscar productos',
      selectedFilter: 'Filtros seleccionados',
      clearAll: 'Limpiar todo',
      noPageFound: 'No se ha encontrado ninguna página',
      outOfStock: 'Agotado',
    };
  } else if (Shopify.locale == "fr") {
    algolia.translations = {
      search: 'Recherche',
      noCollectionFound: 'Aucune collection trouvée',
      allProducts: 'Voir tous les produits',
      matching: 'correspondance',
      sortBy: 'Trier par',
      relevance: 'Pertinence',
      outOf: 'hors de',
      resultsFound: 'résultats trouvés',
      oneResultFound: '1 résultat trouvé',
      noResultFound: "Aucun resultat n'a été trouvé",
      addToCart: 'Ajouter au panier',
      searchForProduct: 'Recherche de produits',
      selectedFilter: 'Filtres sélectionnés',
      clearAll: 'Tout effacer',
      noPageFound: 'Aucune page trouvée',
      outOfStock: 'Épuisé',
    };
  } else {
    algolia.translations = {
      search: 'Recherche',
      noCollectionFound: 'Aucune collection trouvée',
      allProducts: 'Voir tous les produits',
      matching: 'correspondance',
      sortBy: 'Trier par',
      relevance: 'Pertinence',
      outOf: 'hors de',
      resultsFound: 'résultats trouvés',
      oneResultFound: '1 résultat trouvé',
      noResultFound: "Aucun resultat n'a été trouvé",
      addToCart: 'Ajouter au panier',
      searchForProduct: 'Recherche de produits',
      selectedFilter: 'Filtres sélectionnés',
      clearAll: 'Tout effacer',
      noPageFound: 'Aucune page trouvée',
      outOfStock: 'Épuisé',
    };
  }

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'No result for query ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
